export default "__VITE_ASSET__SLECS9RVvDI9k1rbqqFKLQ__"